import {getKeyedCopy} from "@repo/utils/keyedCopy";

/** Structural subset of `ModalityRow` (LearningFormatParts.tsx) — enough to resolve a slug. */
type ModalitySlugRow = {
	modality: {_id: string; slug: {current: string}};
	isSelected: boolean;
};

const IN_PERSON_MODALITY_SLUG = "in-person";

export const SINGLE_IN_PERSON_NO_CAMPUS_TITLE = {
	key: "single-in-person-no-campus-title",
	fallback: "Choose your format",
} as const;

export const SINGLE_IN_PERSON_NO_CAMPUS_SUBTITLE = {
	key: "single-in-person-no-campus-subtitle",
	fallback: "Select a format to see scheduling.",
} as const;

/** True only on the transition into the Learn more panel, not while it stays open or closes. */
export function didOpenLearnMore(
	nextValue: string | null,
	previousValue: string | null,
	learnMoreValue: string
): boolean {
	return nextValue === learnMoreValue && previousValue !== learnMoreValue;
}

export function getSelectedModalitySlug(
	modalityRows: ModalitySlugRow[]
): string | null {
	return (
		modalityRows.find((row) => row.isSelected)?.modality.slug.current ?? null
	);
}

export function isSingleInPersonNoCampus({
	modalityCount,
	modalitySlug,
	selectedCampusId,
}: {
	modalityCount: number;
	modalitySlug: string | null | undefined;
	selectedCampusId: string | null;
}): boolean {
	return (
		modalityCount === 1 &&
		modalitySlug === IN_PERSON_MODALITY_SLUG &&
		selectedCampusId == null
	);
}

export function getLearningFormatSectionCopy({
	sectionTitle,
	sectionBody,
	keyedCopy,
	modalityCount,
	modalitySlug,
	selectedCampusId,
	defaultTitle,
	defaultSubtitle,
}: {
	sectionTitle: string | null | undefined;
	sectionBody: string | null | undefined;
	keyedCopy: {key: string; text: string}[];
	modalityCount: number;
	modalitySlug: string | null | undefined;
	selectedCampusId: string | null;
	defaultTitle: string;
	defaultSubtitle: string;
}): {title: string; subtitle: string} {
	if (
		isSingleInPersonNoCampus({
			modalityCount,
			modalitySlug,
			selectedCampusId,
		})
	) {
		return {
			title: getKeyedCopy(keyedCopy, SINGLE_IN_PERSON_NO_CAMPUS_TITLE),
			subtitle: getKeyedCopy(keyedCopy, SINGLE_IN_PERSON_NO_CAMPUS_SUBTITLE),
		};
	}

	return {
		title: sectionTitle?.trim() || defaultTitle,
		subtitle: sectionBody?.trim() || defaultSubtitle,
	};
}
